// extracted by mini-css-extract-plugin
module.exports = {"channelsPanel":"_2Gr5L","channel":"_3stq-","selected":"_8gbtv"};